export default function PrivacyPolicy() {
    return (
        <div className="w-full bg-white">
            <div className="max-w-5xl mx-auto px-6 py-14">

                {/* PAGE TITLE */}
                <h1 className="text-3xl font-semibold text-gray-900 mb-6">
                    Privacy Policy
                </h1>

                <p className="text-gray-700 leading-relaxed mb-6">
                    At <strong>Tech Article Hub</strong>, we respect your privacy and are
                    committed to protecting any personal information you may share with us.
                    This Privacy Policy explains how we collect, use, and safeguard your
                    information when you visit our website.
                </p>

                {/* INFORMATION WE COLLECT */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Information We Collect
                </h2>

                <p className="text-gray-700 leading-relaxed mb-4">
                    We may collect limited personal information when you voluntarily provide
                    it, such as when you contact us through a form or email. This information
                    may include your name, email address, and message content.
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We also collect non-personal information automatically, such as browser
                    type, device information, pages visited, and general usage data. This
                    information helps us understand how users interact with our website.
                </p>

                {/* HOW WE USE INFORMATION */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    How We Use Your Information
                </h2>

                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
                    <li>To respond to inquiries and messages</li>
                    <li>To improve website content and user experience</li>
                    <li>To monitor website performance and traffic</li>
                    <li>To comply with legal obligations</li>
                </ul>

                {/* COOKIES */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Cookies and Web Technologies
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Tech Article Hub may use cookies and similar technologies to enhance user
                    experience. Cookies are small data files stored on your device that help
                    us analyze website traffic and usage patterns.
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                    You can choose to disable cookies through your browser settings. Please
                    note that some features of the website may not function properly if
                    cookies are disabled.
                </p>

                {/* GOOGLE ADS */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Google Advertising and Third-Party Services
                </h2>

                <p className="text-gray-700 leading-relaxed mb-4">
                    We may use Google AdSense or other third-party advertising services to
                    display ads on our website. These services may use cookies, including the
                    DoubleClick cookie, to show advertisements relevant to users based on
                    their visits to this and other websites.
                </p>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Google’s use of advertising cookies enables it and its partners to serve
                    ads based on users’ visits to this site and other websites. Users may opt
                    out of personalized advertising by visiting Google Ads Settings.
                </p>

                {/* THIRD PARTY LINKS */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Third-Party Links
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Our website may contain links to third-party websites. We are not
                    responsible for the privacy practices or content of those external sites.
                    We encourage users to review the privacy policies of any third-party
                    websites they visit.
                </p>

                {/* DATA SECURITY */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Data Security
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We take reasonable measures to protect your information. However, no
                    method of data transmission over the internet or electronic storage is
                    completely secure. While we strive to protect your data, we cannot
                    guarantee absolute security.
                </p>

                {/* CHILDREN */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Children’s Information
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    Tech Article Hub does not knowingly collect personal information from
                    children under the age of 13. If you believe that a child has provided
                    personal information on our website, please contact us so we can take
                    appropriate action.
                </p>

                {/* POLICY UPDATES */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Updates to This Privacy Policy
                </h2>

                <p className="text-gray-700 leading-relaxed mb-6">
                    We may update this Privacy Policy from time to time. Any changes will be
                    posted on this page, and the updated policy will be effective immediately
                    upon posting.
                </p>

                {/* CONTACT */}
                <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-4">
                    Contact Us
                </h2>

                <p className="text-gray-700 leading-relaxed mb-10">
                    If you have any questions or concerns about this Privacy Policy, you can
                    contact us at <strong>contact@techarticlehub.com</strong>.
                </p>

                <p className="text-sm text-gray-500">
                    Last updated: {new Date().toLocaleDateString("en-US")}
                </p>

            </div>
        </div>
    );
}
